import { CLIENT_ID } from "../../config";

export const setAuthenticationInfo = ({ authenticationResult, username }) => {
  localStorage.setItem(
    `CognitoIdentityServiceProvider.${CLIENT_ID}.${username}.accessToken`,
    authenticationResult.AccessToken,
  );
  localStorage.setItem(
    `CognitoIdentityServiceProvider.${CLIENT_ID}.${username}.refreshToken`,
    authenticationResult.RefreshToken,
  );
  localStorage.setItem(
    `CognitoIdentityServiceProvider.${CLIENT_ID}.${username}.idToken`,
    authenticationResult.IdToken,
  );

  localStorage.setItem(
    `CognitoIdentityServiceProvider.${CLIENT_ID}.LastAuthUser`,
    username,
  );
};
